import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickFinish from '@/components/brick_finish.vue'

let infos = new BrickInfos()

infos.output = '   '
infos.back_classes = ['fas', 'fa-rectangle-landscape', 'text-darkgrey']
infos.front_classes = ['fas', 'fa-flag-checkered', 'text-white']
infos.name = 'finish'
infos.associated_class_name = 'AutomlFinish'
infos.editing_component_name = 'BrickFinish'
infos.editing_component = BrickFinish
infos.descriptions = {
	en: {
		short_tooltip_description: 'End',
		full_tooltip_description:
			"Ends a worfklow (bricks connected to an 'End' brick will be computed first)",
		navbar_name: 'End',
	},
	fr: {
		short_tooltip_description: 'Fin',
		full_tooltip_description:
			"Termine un workflow (les briques connectées à une brique 'Fin' seront calculées en premier)",
		navbar_name: 'Fin',
	},
}
// infos.short_tooltip_description = 'finish_short_tooltip'
// infos.full_tooltip_description = 'finish_full_tooltip'
// infos.navbar_name = 'finish_navbar'
infos.background_color = 'darkgrey'

brick_registerer(infos)
